export default "__VITE_ASSET__BcSfiFMO__"